"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDefaultClient = exports.autoDelivery = exports.subscriptionOrBackup = exports.groupSubscriptionsByParent = void 0;
__exportStar(require("./Client"), exports);
__exportStar(require("./lib/createClient"), exports);
__exportStar(require("./lib/version"), exports);
__exportStar(require("./lib/webstore"), exports);
__exportStar(require("./ProposedDelivery"), exports);
__exportStar(require("./Subscription"), exports);
__exportStar(require("./utils/todayInNj"), exports);
var subscription_1 = require("./utils/subscription");
Object.defineProperty(exports, "groupSubscriptionsByParent", { enumerable: true, get: function () { return subscription_1.groupSubscriptionsByParent; } });
Object.defineProperty(exports, "subscriptionOrBackup", { enumerable: true, get: function () { return subscription_1.subscriptionOrBackup; } });
/** for internal use */
function setDefaultClient(client) {
    exports.autoDelivery = client; // since we need a way to unset it due to the shared context bug, let null through for now
}
exports.setDefaultClient = setDefaultClient;
//# sourceMappingURL=index.js.map